"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.Card = react_1.forwardRef((props, ref) => {
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: ref, backgroundColor: "cardBackground", color: "cardText", borderRadius: "3px", maxWidth: "100%", boxShadow: 2 }, props), void 0));
});
//# sourceMappingURL=index.js.map